import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppModalOverlayRef } from 'src/app/shared/services/app-modal.service';

@Component({
  standalone: false,
  selector: 'app-modal-with-input-text',
  templateUrl: './modal-with-input-text.component.html',
  styleUrls: ['./modal-with-input-text.component.scss']
})
export class ModalWithInputTextComponent implements OnInit, AfterViewInit {

  public formRegister: FormGroup = new FormGroup({});
  
  title: string = '';
  closeButton: boolean = false;
  modalTitleType: 'error' | 'warning' | 'success' | 'pattern' = 'pattern';
  modalType: 'info'| 'confirmation' = 'info';
  content: string = '';
  confirmation: boolean = false;
  buttonOk: boolean = false;
  redirectButtonOk: boolean = false;
  redirectRouter: string = '';
  actionType: string = '';
  reasonText: string = '';

  constructor(
   public dialogRef: AppModalOverlayRef<ModalWithInputTextComponent>,
   private readonly router: Router,
   private readonly formBuilder: FormBuilder,
   private readonly el: ElementRef,
   private readonly renderer: Renderer2,
   private readonly sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.setVariables();
    this.initFormRegister();
  }

  ngAfterViewInit(): void {
    this.renderer.setStyle(this.el.nativeElement, 'display', 'contents');
  }

  get headerIcon(): string {
    switch (this.modalTitleType) {
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      case 'success':
        return 'check_circle';
      default:
        return 'info';
    }
  }

  get headerIconTone(): string {
    switch (this.modalTitleType) {
      case 'error':
        return 'danger';
      case 'warning':
        return 'warning';
      case 'success':
        return 'success';
      default:
        return 'default';
    }
  }

  get safeContent(): string {
    return this.sanitizer.sanitize(SecurityContext.HTML, this.content) ?? '';
  }

  public initFormRegister(): void {
    this.formRegister = this.formBuilder.group({
      reasonText: ['', [Validators.required]]
    })
  }

  confirm(): void{
    this.dialogRef.data = {
      confirmation: true,
      reasonText: this.formRegister.get("reasonText")?.value
    };
    this.dialogRef.close(this.dialogRef.data);
  }

  close(): void{
    this.dialogRef.close();
  }

  confirmWithButtonOk(): void{
    if (this.redirectButtonOk && this.redirectRouter) {
      this.router.navigate([`/${this.redirectRouter}`]);
    }
    this.dialogRef.close(this.dialogRef.data);
  }

  setVariables(): void{
    const data = this.dialogRef.data;
    if(data) {
      this.title = data.title ?? data.title;
      this.modalTitleType = data.modalTitleType ?? data.modalTitleType;
      this.modalType = data.modalType ?? data.modalType;
      this.content = data.content ?? data.content;
      this.confirmation = data.confirmation ?? data.confirmation;
      this.closeButton = data.closeButton ?? data.closeButton;
      this.buttonOk = data.buttonOk ?? data.buttonOk;
      this.redirectButtonOk = data.redirectButtonOk ?? data.redirectButtonOk;
      this.redirectRouter = data.redirectRouter ?? data.redirectRouter;
      this.actionType = data.actionType ?? data.actionType
    }
  }

}
